'use client'

import type { PropsWithChildren } from 'react'

import { DialogContextProvider } from './Dialog.context'
import ToastProvider from './ToastContext/Toast.context'

export interface UiV6ProviderProps extends PropsWithChildren {}

/**
 * Combined provider for all UI-V6 contexts
 * Wraps DialogContextProvider and ToastProvider
 */
export const UiV6Provider = ({ children }: UiV6ProviderProps) => {
  return (
    <DialogContextProvider>
      <ToastProvider>{children}</ToastProvider>
    </DialogContextProvider>
  )
}
